import { hideModal } from '@shared/ui/modal.util';

const skrillLogin = 'https://account.skrill.com/login';

class SkrillModalController {
  goToSkrill() {
    hideModal('skrillModal');

    window.open(skrillLogin, 'Ratting', 'left=700, top=300, width=600, height=400');
  }
}

export default SkrillModalController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/deposit/component/skrill.modal.controller.js